import React from "react";
import { StyleSheet, View } from "react-native";
import { Text, useTheme } from "react-native-paper";
import { useTranslation } from "react-i18next";

interface WarehouseItem {
  name: string;
  quantity: number;
}

type WarehouseItems = {
  [itemId: string]: WarehouseItem;
};

interface WarehouseItemsDisplayProps {
  value: WarehouseItems | undefined;
  label?: string;
  hideIfEmpty?: boolean;
}

export const WarehouseItemsDisplay = ({
  value,
  label,
  hideIfEmpty = true,
}: WarehouseItemsDisplayProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  // Handle object structure: { "itemId": { name: "...", quantity: N } }
  const warehouseItems = value || {};
  const warehouseItemsArray = Object.entries(warehouseItems).map(
    ([itemId, itemData]: [string, any]) => ({
      itemId,
      name: itemData?.name || itemId,
      quantity: itemData?.quantity || 0,
    }),
  );

  // Don't display if empty (when hideIfEmpty is true)
  if (hideIfEmpty && warehouseItemsArray.length === 0) {
    return null;
  }

  return (
    <View>
      {label && <Text variant="titleSmall">{t(label)}:</Text>}
      <View style={{ gap: 10, marginTop: 5 }}>
        {warehouseItemsArray.map((item, index) => (
          <View key={index} style={styles.chip}>
            <Text>{item.name}</Text>
            <Text>× {item.quantity}</Text>
          </View>
        ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  chip: {
    flex: 1,
    alignItems: "center",
    borderRadius: 8,
    flexDirection: "row",
    justifyContent: "space-between",
  },
});
